<template>
    <div>
        <section class="header-titre">
            <div class="container">
                <div class="wrap-titre">
                    <h1 class="titre">
                        <slot name="titre" v-if="!form.showPrivate"></slot>
                        <slot name="titre-prive" v-else></slot>
                    </h1>
                </div>
                <div class="head-cta" v-if="isLogged">
                    <div class="switch-wrap">
                        <input type="checkbox" id="private" v-model="form.showPrivate">
                        <label for="private">
                            <div class="switch"><span></span></div>
                            <div class="switch-label">
                                <slot name="swith-label"></slot>
                            </div>
                        </label>

                    </div>
                </div>
            </div>
        </section>
        <section class="documentation">
            <div class="container">

                <section class="filters">
                    <div class="wrap-head-filters">
                        <ul class="filtre-taaf-rnn" v-if="!breakpointDownMd">
                            <li v-for="(item, index) in filters"><a href="" :class="{active: form.taxoId === item.id}"
                                                                    @click.prevent="filtreSite(item.id)">{{item.label}}</a>
                            </li>
                        </ul>
                        <custom-select
                                class="mobile-custom-select"
                                value-field="id"
                                label-field="label"
                                :options="filters"
                                v-model="form.taxoId"
                                @change="filtreSite(null, true)"
                                v-if="breakpointDownMd"></custom-select>
                        <div class="custom-select-year">
                            <p>Année :</p>
                            <custom-select :options="years" v-model="activeYear"
                                           @change="updateSelect()"></custom-select>
                        </div>
                    </div>
                    <form action="" @submit.prevent="formSubmit()">
                        <div class="form-item word-search">
                            <span class="icon-arrow-right" @click="formSubmit()"></span>
                            <input type="text" name="word" id="word" placeholder="Recherche par mot-clés"
                                   v-model="form.word">
                        </div>
                    </form>
                </section>

                <div class="loader-wrap" v-if="loading">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div id="goto-result"></div>
                <transition-group
                        tag="div"
                        class="list-wrap"
                        v-bind:css="false"
                        v-on:before-enter="beforeEnter"
                        v-on:enter="enter"
                >
                    <article class="item"
                             :class="{focus: form.page === 1 && index === 0}"
                             :key="'key_'+index"
                             :data-index="index"
                             @click="openDownload(index)"
                             v-for="(item,index) in result">
                        <div class="img" :style="'background-image: url('+item.imgUrl+')'" v-if="item.imgUrl"></div>
                        <div class="description" :class="{'mobile-hide':hideDesc(index)}">
                            <h2 class="titre" v-html="item.title"></h2>
                            <div class="rte" v-html="getHtml(item.summary_html)"></div>
                            <p class="type-text">{{item.category}}</p>
                        </div>
                        <div class="type">
                            <p class="type-text">{{item.category}}</p>
                        </div>
                        <div class="cta" :class="{opened: showLinksWrap}">
                            <a :href="item.fileUrls[0].url" target="_blank" class="simple"
                               v-if="item.fileUrls.length === 1"><span class="icon-download"></span></a>
                            <div class="double-wrap" v-else>
                                <a href="" class="double" @click.prevent="openDownload(index)">
                                    <span class="icon-download"></span>
                                </a>
                                <transition name="link-docu">
                                    <div class="links-wrap"
                                         v-if="showLinksWrap && index === activeIndex && !breakpointDownMd"
                                         @mouseleave="hideDownload()">
                                        <a :href="item.fileUrls[0].url" target="_blank">
                                            <span class="label">{{item.fileUrls[0].category}}</span><span
                                                class="icon-download"></span>
                                        </a>
                                        <a :href="item.fileUrls[1].url" target="_blank">
                                            <span class="label">{{item.fileUrls[1].category}}</span><span
                                                class="icon-download"></span>
                                        </a>

                                    </div>
                                </transition>
                            </div>
                        </div>
                        <transition name="fade-q">
                            <div class="mobile-download"
                                 :class="{simple:item.fileUrls.length === 1}"
                                 v-if="showLinksWrap && index === activeIndex && breakpointDownMd">
                                <a :href="item.fileUrls[0].url">
                                    <span class="label">{{item.fileUrls[0].category}}</span>
                                </a>
                                <a v-if="item.fileUrls[1]" :href="item.fileUrls[1].url">
                                    <span class="label">{{item.fileUrls[1].category}}</span>
                                </a>
                            </div>
                        </transition>
                    </article>
                </transition-group>
                <p v-if="result && result.length === 0" class="no-results">
                    <slot name="no-results"></slot>
                </p>
                <div class="clearfix"></div>
                <pagination
                        v-if="!loading && showPagination"
                        :pagination="pagination"
                        :params="form"
                        :offset="2"
                        @paginate="formSubmit"></pagination>
            </div>
        </section>
    </div>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"
    import Animation from "../../mixins/animation"
    import Scrolling from "../../libs/Scrolling"
    import {truncate} from "lodash";

    export default {
        mixins: [Ajax, Animation],
        props: {
            isLogged: {
                type: Boolean,
                required: true
            },
            filters: {
                type: Array,
                required: true,
            },
            years: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                result: null,
                loading: false,
                pagination: {},
                firstLoad: true,
                form: {
                    page: 1,
                    word: "",
                    taxoId: "",
                    year: "",
                    showPrivate: false
                },
                showLinksWrap: false,
                activeIndex: null,
                activeYear: null,
            };
        },
        watch: {
            showPrivate(newVal) {
                this.reInitForm()
                this.formSubmit()
            }
        },
        computed: {
            showPagination() {
                if ((this.pagination.current_page === this.pagination.last_page) && this.pagination.current_page === 1) {
                    return false
                } else {
                    return true
                }
            },
            showPrivate() {
                return this.form.showPrivate
            },
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
            breakpointDownSm() {
                return this.$root.breakpointDownSm;
            },


        },
        methods: {
            formSubmit(form) {
                this.loading = true;
                this.result = null;
                if (form) {
                    this.form = form;
                }
                if (!this.form.page) {
                    this.form.page = 1;
                }

                if (!this.firstLoad) {
                    Scrolling.scrollTo("#goto-result", "easeOutCubic", 600, 200);

                }

                this.ajax("library", "getLibrary", {form: this.form}).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.loading = false;
                        this.result = data.result;
                        this.pagination = data.pagination;
                        this.firstLoad = false

                    } else {
                        console.log("error");
                    }
                });


            },
            hideDesc(index) {
                if (this.activeIndex === index && this.showLinksWrap) {
                    return true
                } else {
                    return false
                }
            },
            filtreSite(taxoId, mobile = false) {
                this.form.page = 1
                this.activeYear = this.years[0]
                this.form.year = this.activeYear.value
                if (!mobile) {
                    this.form.taxoId = taxoId
                }
                this.formSubmit()
            },
            openDownload(index) {
                this.activeIndex = index

                if (!this.breakpointDownMd) {
                    this.showLinksWrap = true
                    return
                }

                if (this.breakpointDownMd && this.showLinksWrap) {
                    this.showLinksWrap = false
                } else {
                    this.showLinksWrap = true
                }
            },
            hideDownload() {
                this.activeIndex = null
                this.showLinksWrap = false
            },
            updateSelect() {
                this.form.page = 1
                this.form.year = this.activeYear.value
                this.formSubmit()
            },
            reInitForm() {
                this.form.taxoId = ""
                this.form.word = ""
                this.activeYear = this.years[0]
            },
            getHtml(item) {
                let length = 250
                if (this.breakpointDownMd) {
                    length = 70
                }

                return truncate(item, {
                    "length": length,
                    "omission": "..."
                })
            },

        },
        created() {
            this.animDelta = 100
            this.activeYear = this.years[0]
        },
        mounted() {
            this.formSubmit()
        },
        destroyed() {
        }
    };
</script>
